/* eslint-disable */

/** unique or primary key constraints on table "argo.auth_provider_record" */
export enum ArgoAuthProviderRecordConstraint {
  /** unique or primary key constraint on columns "auth_provider_record_id" */
  AuthProviderRecordPkey = 'auth_provider_record_pkey'
}

/** select columns of table "argo.auth_provider_record" */
export enum ArgoAuthProviderRecordSelectColumn {
  /** column name */
  AuthProviderId = 'auth_provider_id',
  /** column name */
  AuthProviderRecordId = 'auth_provider_record_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Meta = 'meta'
}

/** update columns of table "argo.auth_provider_record" */
export enum ArgoAuthProviderRecordUpdateColumn {
  /** column name */
  AuthProviderId = 'auth_provider_id',
  /** column name */
  AuthProviderRecordId = 'auth_provider_record_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Meta = 'meta'
}

